var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTimeGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.500061H4.5V1.50006H7.5V0.500061Z",
    fill: "#797D8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.515 3.69506L10.225 2.98506C10.01 2.73006 9.775 2.49006 9.52 2.28006L8.81 2.99006C8.035 2.37006 7.06 2.00006 6 2.00006C3.515 2.00006 1.5 4.01506 1.5 6.50006C1.5 8.98506 3.51 11.0001 6 11.0001C8.49 11.0001 10.5 8.98506 10.5 6.50006C10.5 5.44006 10.13 4.46506 9.515 3.69506ZM6.5 7.00006H5.5V4.00006H6.5V7.00006Z",
    fill: "#797D8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeGray);
export default __webpack_public_path__ + "static/media/icon_time_gray.c22143596b20a8e15f2d3e2b1715685a.svg";
export { ForwardRef as ReactComponent };